import {
  selectState,
  selectEmployeeForOperation,
  setDeleteEmployeeModalOpen,
  getEmployees,
} from "../employeeSlice";
import { useSelector } from "react-redux";
import { useAppDispatch } from "hooks/hooks";
import Modal from "components/Modal/Modal";
import { hrService } from "Dashboard/scenes/HumanResources/services/hr.services";

const DeleteEmployeeModal = () => {
  const { deleteEmployeeModalOpen } = useSelector(selectState);
  const employee = useSelector(selectEmployeeForOperation);
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(setDeleteEmployeeModalOpen({ visible: false, index: -1 }));
  };

  const deleteEmployee = async () => {
    try {
      await hrService.deleteEmployee(employee?.employeeId);
      dispatch(getEmployees({}));
      close();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal
      isOpen={deleteEmployeeModalOpen}
      onClose={close}
      onClick={deleteEmployee}
      title="Brisanje zaposlenog"
    >
      <p className="info-msg">
        Da li ste sigurni da želite da obrišete sledećeg zaposlenog:
        <br />
        <br />
        <b>{employee?.employeeName}?</b>
      </p>
    </Modal>
  );
};

export default DeleteEmployeeModal;
